import { CurrencySetting } from "../../type";

export type CoinDozerGameData = {
  triggeredCoins: TriggeredCoin[];
};

export type CoinDozerPayoutDto = {
  symbolId: CoinDozerSymbolEnum;
  count: number;
  triggerCount: number;
};

export type TriggeredCoin = {
  subType: number;
  coin: CoinDozerPayoutDto;
  multiplier: number;
};

export enum CoinDozerSymbolEnum {
  ZeroCoin = 0,
  OneCoin = 101,
  TwoCoin = 102,
  ThreeCoin = 103,
  DropCoin = 104,
  Cherry1 = 201,
  Cherry2 = 202,
  Cherry3 = 203,
  Bar1 = 301,
  Bar2 = 302,
  Bar3 = 303,
  X2Coin1 = 621,
  X2Coin2 = 622,
  X2Coin3 = 623,
  X2Coin4 = 624,
  X2Coin5 = 625,
  X2Coin6 = 626,
  X3Coin1 = 631,
  X3Coin2 = 632,
  X3Coin3 = 633,
  X3Coin4 = 634,
  X3Coin5 = 635,
  X3Coin6 = 636,
  SevenBedazzle = 401,
  Ring = 402,
  Watch = 403,
  Phone = 404,
  Crown = 405,
  FeatureWallAndThrow = 501,
  FeatureRoulette = 502,
  FeaturePushCoins = 503,
  FeatureThreeBall = 504,
  FeatureThrowCoins = 505,
  FeatureLuckyBonus = 506,
}

export type Rule = {
  payouts: { [k: string]: number[] };
};

export type Setting = {
  currencies: CurrencySetting[];
  payouts: { [k: string]: number[] };
};
